import { render } from "./tableView.vue?vue&type=template&id=04a712fd&scoped=true"
import script from "./tableView.vue?vue&type=script&lang=js"
export * from "./tableView.vue?vue&type=script&lang=js"

import "./tableView.vue?vue&type=style&index=0&id=04a712fd&scoped=true&lang=css"
import "./tableView.vue?vue&type=style&index=1&id=04a712fd&scoped=true&lang=css"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a712fd"]])

export default __exports__